function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.75px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_2",
  "data-name": "Group 2",
  transform: "translate(-87.625 -33.722)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_1",
  "data-name": "Group 1",
  transform: "translate(88 34.097)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_1",
  d: "M0 0L0 3.762",
  className: "prefix__cls-1",
  "data-name": "Line 1",
  transform: "translate(3.801)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_2",
  d: "M0 0L0 3.762",
  className: "prefix__cls-1",
  "data-name": "Line 2",
  transform: "translate(7.563)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_3",
  d: "M0 0L0 3.762",
  className: "prefix__cls-1",
  "data-name": "Line 3",
  transform: "translate(11.326)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_3",
  d: "M102.08 42.863h1.3a.752.752 0 0 0 .751-.752v-3.694a6.788 6.788 0 0 0-.091-1.107 3.837 3.837 0 0 0-3.786-3.212H89.445A1.445 1.445 0 0 0 88 35.542v6.079l3.144 1.241",
  className: "prefix__cls-1",
  "data-name": "Path 3",
  transform: "translate(-88 -34.097)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_4",
  d: "M0 0L5.98 0",
  className: "prefix__cls-1",
  "data-name": "Line 4",
  transform: "translate(5.622 8.766)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_4",
  d: "M96.713 50.221a1.241 1.241 0 1 1-1.241-1.241 1.241 1.241 0 0 1 1.241 1.241z",
  className: "prefix__cls-1",
  "data-name": "Path 4",
  transform: "translate(-91.089 -41.476)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_5",
  d: "M113.487 50.221a1.241 1.241 0 1 1-1.241-1.241 1.241 1.241 0 0 1 1.241 1.241z",
  className: "prefix__cls-1",
  "data-name": "Path 5",
  transform: "translate(-99.405 -41.476)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_5",
  d: "M11.326 0L0 0",
  className: "prefix__cls-1",
  "data-name": "Line 5",
  transform: "translate(0 3.762)"
})), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_8",
  d: "M110.462 41.558s.856 2.4 4.809 2.4",
  className: "prefix__cls-1",
  "data-name": "Path 8",
  transform: "translate(-11.136 -3.699)"
}));

var SvgCars = function SvgCars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10.737,
    viewBox: "0 0 16.885 10.737",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cars.9dfb654a.svg";
export { ForwardRef as ReactComponent };